<template>
  <div class="content keyword-wrap">
    <div class="page-header"  :class="{ 'not-allowed': !$root.checkFeature('messages_keywords')}">

      <div class="flex px-4 md:block">
        <div class="w-72 lg:w-60 px-4 pt-4 md:hidden">
          <img :src="require('./icons/keyword.svg')" width="210px"/>
        </div>

        <div class="mt-6 lg:mt-4">
          <div class="font-semibold text-3xl md:text-xl">Keywords</div>
          <p class="md:hidden">Create a keyword with an automatic text message response</p>
          <div  class="flex justify-between mt-6 lg:mt-3">
            <div class="text-center">
              <span class="font-black text-4xl md:text-xl">{{ keywordData.registered }} of {{ keywordData.total }}</span>
              <div class="md:text-sm mt-2">Keywords used</div>
            </div>
            <div class="text-center px-3">
              <span class="font-black text-4xl md:text-xl">{{ totalReciepients }}</span>
              <div class="md:text-sm mt-2">Total Views</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="flex justify-between md:items-center md:flex-col-reverse bg-white shadow-sm px-8 py-3 lg:px-4">
      <h1 class="m-0 text-2xl">
        Keywords
      </h1>
      <div class="md:mb-4 sm:w-full">
        <el-tooltip  v-if="keywordData.registered === keywordData.total" placement="top-start">
          <template #content>You have used all available Keywords - Upgrade for more</template>
          <el-button type="primary" class="is-disabled" size="medium">
            <font-awesome-icon class="mr-2 lg:mr-0 text-xs leading-2"
                                :icon="['fas', 'plus']"/>
            <span class="lg:hidden">New Keyword</span>
          </el-button>
        </el-tooltip>
        <el-button v-else type="primary" size="medium" v-on:click.prevent="$router.push({name: 'addKeyword'});">
          <font-awesome-icon class="mr-2 lg:mr-0 text-xs leading-2"
                              :icon="['fas', 'plus']"/>
          <span class="lg:hidden">New Keyword</span>
        </el-button>
      </div>

    </div>
    
    <div class="container-fluid ">
      <div class="row px-8 py-3">
        <div class="s-block shadow-md">
          <div class="s-block-header flex justify-between">
            <span>Keywords</span> <span>{{ keywordData.registered }} of {{ keywordData.total }} Keywords Used</span></div>
          <div class="" v-if="activeCharityInfo">
            <el-table
              style = "width: 100%"
              :default-sort = "sorting"
              :data = "itemsDataPage"
              :height = "tableHeight + 110"
              v-on:sort-change="sortChange"
            >
              <template slot="empty">
                <div class="empty-placeholder">
                  <img :src="require('../../assets/paceholders/30.svg')" alt="No results">
                  <h3>No Keywords</h3>
                </div>
              </template>
              <el-table-column label=""
                                 width="75"
                ></el-table-column>
              <el-table-column 
                label="Keyword"
                prop="keyword"
                :sort-orders="['descending', 'ascending']"
                sortable="custom"
              >
                <template slot-scope="scope">
                  <router-link :to="{ name: 'editKeyword', params: {keyword: scope.row.keyword }}">
                    {{ scope.row.keyword }}
                  </router-link>
                  <div class="info">
                    Keyword
                  </div>
                </template>
              </el-table-column>
              <el-table-column 
                label="Total Views"
                prop="recieved"
                :sort-orders="['descending', 'ascending']"
                sortable="custom"
              >
                <template slot-scope="scope">
                  {{ scope.row.recieved ?  scope.row.recieved : 0 }}
                  <div class="info">
                    Views
                  </div>
                </template>
              </el-table-column>
              <el-table-column 
                label="Phone Number"
              >
                <template slot-scope="scope">
                  26989 
                  <div class="info">
                    Phone Number
                  </div>
                </template>
              </el-table-column>
              <el-table-column 
                label="Message"
                prop="message"
                :sort-orders="['descending', 'ascending']"
                sortable="custom"
              >
                <template slot-scope="scope">
                  <div class="info">
                    {{ scope.row.message }}
                  </div>
                </template>
              </el-table-column>
                <el-table-column label=""
                                 width="75"
                >
                  <template slot-scope="scope">

                    <el-dropdown trigger="click"
                                 @command="handleCommand"
                    >
                      <span class="el-dropdown-link inline-block text-gray-500 text-xl rounded-full h-8 w-8 flex items-center justify-center hover:bg-gray-200">
                        <font-awesome-icon :icon="['far', 'ellipsis-v']"  />
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="['edit', scope.row]">Edit Keyword</el-dropdown-item>
                        <el-dropdown-item :command="['delete', scope.row]">Delete Keyword</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                  </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="text-right"
                background
                :current-page.sync="currentPage"
                layout="prev, pager, next"
                :page-size="paginationInfo.pageSize"
                :total="itemsData.length">
            </el-pagination>
          </div>
        </div>
        
      </div>
    </div>

    <modal v-if="isDeleteModal"
           v-on:close-modal="activeKeyword = null;isDeleteModal = false"
           v-on:delete-keyword="deleteSelectedKeyword"
           :modal-name="'delete-keyword'"></modal>
  </div>
</template>

<script>
  import MsgMenu from './menu.vue';
  import AddAttachment from './add-attachment.vue';
  import scrollInfoMixin from '../../mixins/scroll-info-mixin';
  import AttachmentEdit from './attachment-edit.vue';
  import Modal from '../Modal/index.vue';
  import Attachment from './attachment.vue';
  import dataTableMixin from '../Parts/data-table-mixin';
  import config from '../../../public/harness_config.json';
  import { getCurrentKeyword, deleteKeyword } from '@/utils/api';
  import {mapState} from "vuex";

  export default {
    name: 'Keyword',
    metaInfo: {
      title: 'Keyword',
    },
    mixins: [scrollInfoMixin, dataTableMixin],
    components: {
      MsgMenu,
      Modal,
      AddAttachment,
      AttachmentEdit,
      Attachment,
    },
    mounted() {
      this.upKeyword();
    },
    created() {
      this.sorting = {prop: 'keyword', order: 'descending'};
    },
    methods: {
      sortChange(sorting) {
        this.sorting = sorting
      },
      upKeyword() {
        if (this.activeCharityInfo) {
          getCurrentKeyword(this.activeCharityInfo.charity_id).then(info => {
            if(info.keywords) {
              this.keywords = info.keywords.list
              this.keywordData = info.keywords.quantity
              this.isLoaded = true;
            }
          });
        }
      },
      deleteSelectedKeyword() {
        deleteKeyword(this.activeKeyword).then(() => {
          this.isDeleteModal = false;
          this.upKeyword()
        })
      },
      handleCommand([command, payload]) {
        switch (command){
          case 'edit':
            this.$router.push({name: "editKeyword", params: {keyword: payload.keyword} })
            break
          case 'delete':
            this.activeKeyword = payload.keyword
            this.isDeleteModal = true
            break
        }
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      config() {
        return config;
      },
      itemsData() {
        return this.keywords
      },
      totalReciepients() {
        return this.keywords.reduce((reduced, item) => { 
          reduced = reduced + item.received 
          return reduced
        }, 0)
      }

    },
    watch: {
      'activeCharityInfo'() {
        this.upKeyword();
      },
    },
    data() {
      return {
        keyword: '',
        keywords: [],
        keywordData: {},
        activeKeyword: null,
        isLoaded: false,
        isDeleteModal: false,
      };
    },
  };
</script>

<style lang="scss">


  .keyword-wrap {
    .emojionearea .emojionearea-button {
      right: 8px;
    }
    .info{
      margin-top: 4px;
      font-size: 12px;
      line-height: 1.25;
      color: #7f8fa4;
      font-weight: 400; 
    }
    .phone-num {
      color: #0d70e3;
    }

    .keyword-status {
      font-size: 14px;
      color: rgba(53, 64, 82, 0.5);
      line-height: 19px;
    }

    .keyword-status-val {
      font-size: 14px;
      font-weight: 600;
      color: rgba(53, 64, 82, 0.8);
      line-height: 19px;

      &.available {
        color: #1da664;
      }

      &.not-available {
        color: #d35847;
      }

      &.saved {
        color: #0d70e3;
      }
    }
  }


  .preview-block {
    display: inline-block;
    position: relative;
    overflow: hidden;
    width: 188px;
    height: 119px;
    border-radius: 4px;
    background-color: #0d70e3;

    &:first-of-type {
      margin-right: 24px;
    }

    img {
      max-width: 100%;
      height: auto;
      position: absolute;
      right: 0;
      top: -19px;
    }

    span {
      font-size: 14px;
      opacity: 0.8;
      line-height: 1;
    }

    .preview-block-caption {
      color: #ffffff;
      position: absolute;
      bottom: 10px;
      left: 15px;

      .preview-block-counter {
        font-size: 30px;
        opacity: 0.9;
        margin-bottom: 3px;
      }
    }
  }
</style>
